import { render } from "./TaskConfig.vue?vue&type=template&id=63d2088f&scoped=true&ts=true"
import script from "./TaskConfig.vue?vue&type=script&lang=ts"
export * from "./TaskConfig.vue?vue&type=script&lang=ts"

import "./TaskConfig.vue?vue&type=style&index=0&id=63d2088f&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d2088f"]])

export default __exports__